<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <!--<div class="bg">-->
    <div class="container">
      <div class="content">
        <div class="headline">
          <span>{{title}}</span>
        </div>
        <div class="description">
          <p v-bind:class="{ 'p-left': isLeft }">{{desc}}</p>
        </div>
      </div>
    </div>

  <!--</div>-->
</template>
<script>
  export default {
    name: 'homeFirmContent',
    props: ['isSecond', 'title', 'desc', 'isLeft']
  }
</script>
<style scoped>
  /*div.bg {*/
    /*display: flex;*/
  /*}*/
.mart80{
  margin-top: 80px;
}
  div.container {
    padding: 0;
    /*width: 980px;*/
    /*height: auto;*/
    /*display: flex;*/
    /*margin: auto;*/
    background-color: rgb(255, 255, 255);
  }

  /*div.second {*/
    /*background-color: rgb(215, 215, 215);*/
  /*}*/

  div.content {
    padding-top: 80px;
    width: 980px;
    margin: auto;
    height: auto;
  }


  div.headline {
    /*font-weight: 700;*/
    font-size: 24px;
    font-family: PingFangSC-Semibold, "PingFang SC Semibold", "PingFang SC";
    font-style: normal;
    text-align: center;
    padding-bottom: 20px;
  }

  div.description {
    width: auto;
    color: rgb(73,73,73);
    font-weight: 400;
    font-size: 16px;
    font-family: 'Helvetica', 'Helvetica';
    white-space: nowrap;
    margin-top: 4%;
    text-align: center;
  }

  p {
    padding: 0;
    margin: auto;
    width: inherit;
    white-space: pre-wrap;
    text-align: center;
    line-height: 40px;
  }

  p.p-left {
    text-align: left;
  }
  span {
    color: rgb(19,174,47);
    border-bottom: solid;
    border-color: rgb(19,174,47);
    border-width: 1px;
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 15px;
    padding-bottom: 15px;
  }

</style>



// WEBPACK FOOTER //
// HomeFirmContent.vue?62ebbad5